import { debounce } from 'lodash'
import { format, isWeekend, isAfter } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { is, date } from 'quasar';

const emptyValues = {
	aluguel_financiamento: null,
	agua_energia_gas: null,
	internet_tv_telefone: null,
	transporte_educacao: null,
	compras: null,
	plano_saude: null,
	lazer: null
}

const urlReservaEmergencia = window.location.origin + '/api/reserva_emergencia/'

const urlOpcoesTesouroSelic = window.location.origin + '/api/tesouro_direto/?ticker_symbol=Selic'

const urlMovimentacaoTesouro = window.location.origin + '/api/movimentacao_tesouro/'

export default {
  data() {
    return {
			tipoRequisicao: null,
			stepReservaEmergencia: 0,
			naoSeiPrecisoCalcular: true,
			isCalculating: false,
			objetivo_reserva: null,
			reserva_emergencia: null,
			quanto_falta_reserva: null,
			porcentagem_quanto_falta_reserva: '25%',
			isLoadingReservaEmergencia: true,
			valoresPayload: {
				id: null,
				idade: null,
				seguranca: null,
				tipo_mercado: null,
				facilidade_realocacao: null,
				dependentes: null,
				num_meses: null,
				custo_mensal: null,
				num_meses_manual: false,
				aluguel_financiamento: null,
				agua_energia_gas: null,
				internet_tv_telefone: null,
				transporte_educacao: null,
				compras: null,
				plano_saude: null,
				lazer: null
			},
			erros: [],
			isLoading: false,
			selectsHasFilled: false,
			hasValueInSearch: false,
			errorMessage: '',
			modalValueIsValid: true,
			inputIsInvalid: false,
			corretagem: '',
			optionsPadronizadas: [
				{ label: "Renda fixa", value: "TesouroDireto", id: 5 },
			],
			tesouroOptions: [],
			tipo_ativo: {
				id: 5,
				label: "Renda fixa",
				value: "TesouroDireto"
			},
			payloadModal: {
				ticker_symbol: "",
				reference_date: "",
				movement_type: "Compra",
				treasury_bonds_quantity: "",
				operation_value: ""
			},
			baseURL: window.location.origin,
    }
  },

	computed: {
		isCalcularConsultaDisabled() {
			const calcularConsultaCondition = 
				!this.valoresPayload.idade ||
				!this.valoresPayload.seguranca ||
				!this.valoresPayload.tipo_mercado ||
				!this.valoresPayload.facilidade_realocacao ||
				!this.valoresPayload.dependentes ||
				// !this.valoresPayload.num_meses ||
				!this.valoresPayload.custo_mensal ||
				this.isCalculating
			return calcularConsultaCondition
		},
		arrCustosMensais() {
			const arrCustos = [this.formatarMonetariaParaDecimal(this.valoresPayload.aluguel_financiamento), this.formatarMonetariaParaDecimal(this.valoresPayload.agua_energia_gas), this.formatarMonetariaParaDecimal(this.valoresPayload.internet_tv_telefone), this.formatarMonetariaParaDecimal(this.valoresPayload.transporte_educacao), this.formatarMonetariaParaDecimal(this.valoresPayload.compras), this.formatarMonetariaParaDecimal(this.valoresPayload.plano_saude), this.formatarMonetariaParaDecimal(this.valoresPayload.lazer)]
			return arrCustos
		},
		sumCustoMensal() {
			const arrCustos = [this.formatarMonetariaParaDecimal(this.valoresPayload.aluguel_financiamento), this.formatarMonetariaParaDecimal(this.valoresPayload.agua_energia_gas), this.formatarMonetariaParaDecimal(this.valoresPayload.internet_tv_telefone), this.formatarMonetariaParaDecimal(this.valoresPayload.transporte_educacao), this.formatarMonetariaParaDecimal(this.valoresPayload.compras), this.formatarMonetariaParaDecimal(this.valoresPayload.plano_saude), this.formatarMonetariaParaDecimal(this.valoresPayload.lazer)]
			const soma = arrCustos.reduce((acc, valor) => acc + (valor ?? 0), 0);
			return soma
		},

		legendaSeguranca() {
			const legendaEscolha = ''
			if (this.valoresPayload.seguranca === 1) {
				legendaEscolha = 'Cargo onde tenho poucas chances de demissão'
			} else if (this.valoresPayload.seguranca === 2) {
				legendaEscolha = 'Cargo estável, porém com alguma chance de demissão'
			} else if (this.valoresPayload.seguranca === 3) {
				legendaEscolha = 'Cargo onde há pouca estabilidade'
			}

			// Alto: Cargo onde tenho poucas chances de demissão
			// Médio: Cargo estável, porém com alguma chance de demissão
			// Baixo: Cargo onde há pouca estabilidade


			return legendaEscolha
		},

		legendaTipoMercado() {
			const legendaEscolha = ''
			if (this.valoresPayload.tipo_mercado === 1) {
				legendaEscolha = 'Baixo risco de impacto em casos de crise - ex.: setores essenciais como saúde ou alimentício'
			} else if (this.valoresPayload.tipo_mercado === 2) {
				legendaEscolha = 'Pode ser impactado em casos de crise, ex.: indústria e setores ligados à ela como Marketing, RH, TI, etc'
			} else if (this.valoresPayload.tipo_mercado === 3) {
				legendaEscolha = 'Grandes chances de ser impactado em casos de crises, ex.: comércio'
			}

			// Estável: Baixo risco de impacto em casos de crise - ex.: setores essenciais como saúde ou alimentício
			// Médio: Pode ser impactado em casos de crise, ex.: indústria e setores ligados à ela como Marketing, RH, TI, etc
			// Instável: Grandes chances de ser impactado em casos de crises, ex.: comércio

			return legendaEscolha
		},

		legendaFacilidadeRealocacao() {
			const legendaEscolha = ''
			if (this.valoresPayload.facilidade_realocacao === 1) {
				legendaEscolha = 'Fácil realocação - mercado possui maior demanda do que oferta e você possui alta qualificação'
			} else if (this.valoresPayload.facilidade_realocacao === 2) {
				legendaEscolha = 'Realocação média - mercado concorrido e possui qualificação no mesmo nível que o mercado'
			} else if (this.valoresPayload.facilidade_realocacao === 3) {
				legendaEscolha = 'Possível dificuldade de realocação - mercado saturado e com pouca oferta de emprego'
			}

			// Baixa: Fácil realocação - mercado possui maior demanda do que oferta e você possui alta qualificação
			// Média: Realocação média - mercado concorrido e possui qualificação no mesmo nível que o mercado
			// Alta: Possível dificuldade de realocação - mercado saturado e com pouca oferta de emprego

			return legendaEscolha
		},

		/////////////////////////////////////////////////////
		minDate() {
			const currentDate = new Date();
			console.log(currentDate)
			const minYear = currentDate.getFullYear() - 5;
			let min = new Date(currentDate);

			// Se o dia atual for sábado (6) ou domingo (0), ajuste minDate para o próximo dia útil (segunda-feira)
			if (min.getDay() === 6) {
				console.log('SABADO')
				min.setDate(min.getDate() + 2);
			} else if (min.getDay() === 0) {
				console.log('DOMINGO')
				min.setDate(min.getDate() + 1);
			} else {
				console.log('OUTRO DIA')
				min = new Date(minYear, min.getMonth(), min.getDate());
			}
			const isStockOrREIT =
				this.tipo_ativo === 'Stock' ||
				this.tipo_ativo === 'REIT' ||
				(this.tipo_ativo && this.tipo_ativo.value === 'Stock') ||
				(this.tipo_ativo && this.tipo_ativo.value === 'REIT');
			// console.log(`${minYear}-${min.getMonth() + 1}-${min.getDate() + 1}`)				
			if (isStockOrREIT) {
				const dateCorrect = `${min.getDay()}/${min.getMonth() + 1}/${min.getFullYear()}`
				return dateCorrect
			}
			return ''
		},
		////////////////////////////////////////////////////
	},

	watch: {
		sumCustoMensal: {
			handler:function(newVal, oldVal) {
				console.log("new Value is " + newVal)
				// this.valoresPayload.custo_mensal = newVal.toLocaleString().replaceAll('.', '')
			},
			deep:true
		},
		valoresPayload: {
			handler:function(newVal, oldVal) {
				const valoresIndividuais = {
					aluguel_financiamento: newVal.aluguel_financiamento,
					agua_energia_gas: newVal.agua_energia_gas,
					internet_tv_telefone: newVal.internet_tv_telefone,
					transporte_educacao: newVal.transporte_educacao,
					compras: newVal.compras,
					plano_saude: newVal.plano_saude,
					lazer: newVal.lazer,
				}
				if (!_.isEqual(valoresIndividuais, emptyValues)) {
					// this.valoresPayload.custo_mensal = this.sumCustoMensal.toFixed(2).replace('.', ',')
					this.valoresPayload.custo_mensal = this.changeToMonetarioBrl(this.sumCustoMensal)
				}
			},
			deep:true
		},
    stepReservaEmergencia: {
			handler:function(newVal, oldVal) {
				if (newVal === 0) {
					this.applyModalAport()
				}
			},
     deep:true
    },
  },

  methods: {

		changeToMonetarioBrl (valor) {
			if (!valor) return null
			return valor.toLocaleString('pt-BR',{ minimumFractionDigits: 2 })
		},

		changeToFloatApi (valor) {
			if (!valor) return null
			return valor.replaceAll('.', '').replace(',', '.')
		},

    escolherOpcaoIdade(opcao, valor) {
			switch (opcao) {
				case "idade":
					this.valoresPayload.idade = valor					
					break;
				case "seguranca":
					this.valoresPayload.seguranca = valor				
				break;
				case "tipo_mercado":
					this.valoresPayload.tipo_mercado = valor				
				break;
				case "facilidade_realocacao":
					this.valoresPayload.facilidade_realocacao = valor				
				break;
				case "dependentes":
					this.valoresPayload.dependentes = valor				
				break;			
				default:
					break;
			}
		},

		formatarMonetariaParaDecimal(monetaria) {
			if (!monetaria) return null

			const mon = monetaria.replaceAll('.', '')

			// Remove os caracteres que não são números, ponto ou vírgula
			let numero = mon.replace(/[^\d.,-]/g, '');
	
			// Substitui a vírgula decimal por ponto, se necessário
			if (numero.includes(',')) {
					numero = numero.replace(',', '.');
			}
	
			// Encontra a posição do ponto decimal
			const pontoPos = numero.indexOf('.');
	
			if (pontoPos !== -1) {
					// Trunca a string para duas casas decimais após o ponto
					numero = numero.substring(0, pontoPos + 3);
			}
	
			// Converte a string para um número decimal
			return parseFloat(numero);
		},

		truncateDecimals(input) {
			// Expressão regular para encontrar números decimais
			const regex = /(\d+\,\d{2})\d*/g;
	
			// Função de callback para truncar o número
			const truncatedInput = input.replace(regex, (match, p1) => p1);
	
			return truncatedInput;
		},

		clearValoresIndividuais() {
			this.valoresPayload.aluguel_financiamento = null
			this.valoresPayload.agua_energia_gas = null
			this.valoresPayload.internet_tv_telefone = null
			this.valoresPayload.transporte_educacao = null
			this.valoresPayload.compras = null
			this.valoresPayload.plano_saude = null
			this.valoresPayload.lazer = null
		},

		validateValueInputPrice(event, payloadName) {
			console.log(event.target.value)
			this[payloadName][event.target.name] = event.target.value
		},

		validateValueInputQuantity(event) {
			const inputValue = event.target.value;
			let numerosValidos = false;
			const removerCaracteres = (string, regexValue) => string.replace(regexValue, '');
			numerosValidos = /^[0-9]+$/.test(inputValue)
			if (!numerosValidos) {
				event.target.value = removerCaracteres(inputValue, /[^0-9]/g)
			}
		},

		calcularPorcentagem(parte, total) {
			if (total === 0) {
				return 0;
			}
			let porcentagem = (parte / total) * 100;
			const procentagemDuasCasas = Math.round((porcentagem + Number.EPSILON) * 100) / 100
			return `${procentagemDuasCasas}%`;
			// return Math.round((porcentagem + Number.EPSILON) * 100) / 100
	  },

		setarValoresQuadroObjetivo (valor) {
			const subtracaoObjetivoReserva = valor.objetivo_reserva - valor.reserva_emergencia
			this.objetivo_reserva = valor.objetivo_reserva === 0 ? valor.objetivo_reserva.toFixed(2).replace('.', ',') : this.changeToMonetarioBrl(valor.objetivo_reserva)
			this.reserva_emergencia = valor.reserva_emergencia === 0 ? valor.reserva_emergencia.toFixed(2).replace('.', ',') : this.changeToMonetarioBrl(valor.reserva_emergencia)
			this.quanto_falta_reserva = subtracaoObjetivoReserva === 0 ? subtracaoObjetivoReserva.toFixed(2).replace('.', ',') : this.changeToMonetarioBrl(subtracaoObjetivoReserva)
			this.porcentagem_quanto_falta_reserva = this.calcularPorcentagem(parseFloat(valor.reserva_emergencia), valor.objetivo_reserva)
		},

		async getDadosReservaEmergencia() {
			try {
				this.isLoadingReservaEmergencia = true
				const { data } = await axios.get(urlReservaEmergencia)
				if (data.length > 0) {
					this.tipoRequisicao = 'PATCH'
					this.valoresPayload = {
						id: data[0].id,
						idade: data[0].idade,
						seguranca: data[0].seguranca,
						tipo_mercado: data[0].tipo_mercado,
						facilidade_realocacao: data[0].facilidade_realocacao,
						dependentes: data[0].dependentes,
						num_meses: data[0].num_meses,
						num_meses_manual: data[0].num_meses_manual,
						custo_mensal: !Boolean(parseFloat(data[0].custo_mensal)) ? null : this.changeToMonetarioBrl(parseFloat(data[0].custo_mensal)),
						aluguel_financiamento: !Boolean(parseFloat(data[0].aluguel_financiamento)) ? null : this.changeToMonetarioBrl(parseFloat(data[0].aluguel_financiamento)),
						agua_energia_gas: !Boolean(parseFloat(data[0].agua_energia_gas)) ? null : this.changeToMonetarioBrl(parseFloat(data[0].agua_energia_gas)),
						internet_tv_telefone: !Boolean(parseFloat(data[0].internet_tv_telefone)) ? null : this.changeToMonetarioBrl(parseFloat(data[0].internet_tv_telefone)),
						transporte_educacao: !Boolean(parseFloat(data[0].transporte_educacao)) ? null : this.changeToMonetarioBrl(parseFloat(data[0].transporte_educacao)),
						compras: !Boolean(parseFloat(data[0].compras)) ? null : this.changeToMonetarioBrl(parseFloat(data[0].compras)),
						plano_saude: !Boolean(parseFloat(data[0].plano_saude)) ? null : this.changeToMonetarioBrl(parseFloat(data[0].plano_saude)),
						lazer: !Boolean(parseFloat(data[0].lazer)) ? null : this.changeToMonetarioBrl(parseFloat(data[0].lazer))
					}
					this.setarValoresQuadroObjetivo(data[0])
				} else {
					this.tipoRequisicao = 'POST'
				}
			} catch (error) {
				console.log(error)
			} finally {
				this.isLoadingReservaEmergencia = false
			}
		},

		onInputCustoMensal(event) {
			this.validateValueInputPrice(event, 'valoresPayload')
			const valoresIndividuais = {
				aluguel_financiamento: this.valoresPayload.aluguel_financiamento,
				agua_energia_gas: this.valoresPayload.agua_energia_gas,
				internet_tv_telefone: this.valoresPayload.internet_tv_telefone,
				transporte_educacao: this.valoresPayload.transporte_educacao,
				compras: this.valoresPayload.compras,
				plano_saude: this.valoresPayload.plano_saude,
				lazer: this.valoresPayload.lazer,
			}
			if (!_.isEqual(valoresIndividuais, emptyValues) && this.sumCustoMensal !== this.formatarMonetariaParaDecimal(event.target.value)) {
				this.clearValoresIndividuais()
			}
		},

		async calcularReservaEmergencia() {
			const payloadReservaEmergencia = { ...this.valoresPayload }
			payloadReservaEmergencia.custo_mensal = this.changeToFloatApi(payloadReservaEmergencia.custo_mensal)

			payloadReservaEmergencia.aluguel_financiamento = parseFloat(payloadReservaEmergencia.aluguel_financiamento) === 0 ? null : this.changeToFloatApi(payloadReservaEmergencia.aluguel_financiamento)
			payloadReservaEmergencia.agua_energia_gas = parseFloat(payloadReservaEmergencia.agua_energia_gas) === 0 ? null : this.changeToFloatApi(payloadReservaEmergencia.agua_energia_gas)
			payloadReservaEmergencia.internet_tv_telefone = parseFloat(payloadReservaEmergencia.internet_tv_telefone) === 0 ? null : this.changeToFloatApi(payloadReservaEmergencia.internet_tv_telefone)
			payloadReservaEmergencia.transporte_educacao = parseFloat(payloadReservaEmergencia.transporte_educacao) === 0 ? null : this.changeToFloatApi(payloadReservaEmergencia.transporte_educacao)
			payloadReservaEmergencia.compras = parseFloat(payloadReservaEmergencia.compras) === 0 ? null : this.changeToFloatApi(payloadReservaEmergencia.compras)
			payloadReservaEmergencia.plano_saude = parseFloat(payloadReservaEmergencia.plano_saude) === 0 ? null : this.changeToFloatApi(payloadReservaEmergencia.plano_saude)
			payloadReservaEmergencia.lazer = parseFloat(payloadReservaEmergencia.lazer) === 0 ? null : this.changeToFloatApi(payloadReservaEmergencia.lazer)

			if (!payloadReservaEmergencia.num_meses || !payloadReservaEmergencia.num_meses_manual) delete payloadReservaEmergencia.num_meses
			if (!payloadReservaEmergencia.num_meses) {
				this.valoresPayload.num_meses_manual = false
				payloadReservaEmergencia.num_meses_manual = false
			}
			delete payloadReservaEmergencia.id
			try {
				this.isCalculating = true
				const { data } = this.tipoRequisicao === 'POST' ? await axios.post(urlReservaEmergencia, payloadReservaEmergencia) : await axios.patch(`${urlReservaEmergencia}${this.valoresPayload.id}/`, payloadReservaEmergencia)
				this.setarValoresQuadroObjetivo(data)
				this.valoresPayload.custo_mensal = parseFloat(data.custo_mensal) === 0 ? parseFloat(data.custo_mensal).toFixed(2).replace('.', ',') : parseFloat(data.custo_mensal).toLocaleString()
				this.valoresPayload.num_meses = data.num_meses
				this.valoresPayload.id = data.id
				if (this.tipoRequisicao === 'POST') {
					this.tipoRequisicao = 'PATCH'
				}
				console.log(data)
			} catch (error) {
				console.log(error)
			} finally {
				this.isCalculating = false
			}
		},

		setPreviousURL() {
			// history.pushState({ previousURL: window.location.href }, '', 'reserva-emergencia');
			localStorage.setItem('lastRoute', 'reserva-emergencia')
		},

		irCalculoReservaEmergencia() {
			this.stepReservaEmergencia = 1
			this.applyMonetaryMask()
		},

		async cancelarReservaEmergencia() {
			this.stepReservaEmergencia = 0
			await this.getDadosReservaEmergencia()
		},
		
		applyMonetaryMask() {
			setTimeout(() => {
				$('.mask-money').maskMoney({
					thousands: '.',
					decimal: ','
				})
			}, 500);
		},

		applyModalAport() {
			setTimeout(() => {
				ModalX('.modal-novo-ativo', {
					deep: true,
					zIndex: 300000,
					zIndexDeep: 20000,
					closeOnDeep: false,
					bgModal: 'rgb(30,33,36)'
				}).init()
			}, 500);
		},

		//////////////////// Funções Modal Novo Aporte /////////////////////////////////

		handleSearchSelect(opcaoSelecionada) {
			

			if (!opcaoSelecionada.value) {
				this.hasValueInSearch = false;
				return
			}
			this.hasValueInSearch = true
			this.selectsHasFilled = true;
			console.log(this.tipo_ativo, 'TIPO ATIVO')
			this.payloadModal.ticker_symbol = opcaoSelecionada.value;
		},

		validateValueInputPriceAporte(event) {
			const inputValue = event.target.value
			const numerosValidos = /^\d+(,\d{1,2})?$/.test(inputValue)
			const removerCaracteres = (string) => string.replace(/[^\d,]|(,\d{3,})|(,\d{1,2}\D)/g, "")
			if (!numerosValidos) {
				event.target.value = removerCaracteres(inputValue)
			}
		},

		format(date) {
			const day = date.getDate();
			const month = date.getMonth() + 1;
			const year = date.getFullYear();

			return `${day}/${month}/${year}`;
		},

		disableDates(date) {
			const today = new Date();
			const dayOfWeek = date.getDay(); // obter o dia da semana da data
			return date > today || dayOfWeek === 0 || dayOfWeek === 6; // desabilitar datas maiores que hoje ou em fins de semana
		},

		validateModalFields({ target }) {
			console.log(target)

			const isNullish = Object.entries(this.payloadModal).some(([key, value]) => {
				if (key == 'corretagem') return
				if (!value) {
					return true
				}
				return false;
			})

			this.modalValueIsValid = Boolean(!isNullish)
		},

		async openModalNovoAporte(valor, idSelectTipo, idSelectBusca, e) {
			// const ticker = e.currentTarget.getAttribute('data-ticker')?.toLowerCase();

			// const isTesouroIPCAWithoutNumbers = ticker === 'Tesouro IPCA+'.toLowerCase()

			// this.isTesouroDiretoPadrao = isTesouroIPCAWithoutNumbers;
			// const id = e.target.closest('.item.adicionar-manualmente').getAttribute('id')
			// const tipoAtual = e.target.closest('.item.adicionar-manualmente').getAttribute('data-type')
			// await this.getDetalheAtivo(id, tipoAtual)
			// this.origem = 'tabela'
			// this.isDesktop = true
			// this.situation = 'aporte';
			// this.id_choices_tipo = 'id_tipo_investimento_aporte';
			// this.id_choices_busca = 'id_busca_aporte';
			// this.payloadModal.ticker_symbol = isTesouroIPCAWithoutNumbers && this.situation === 'aporte' ? '' : this.dataAtivo.ticker_symbol
			// this.hasValueInSearch = true
			// this.selectsHasFilled = true;
			// this.isEditing = true
			// this.acaoModal = 'adicionar';

			try {
				const { data } = await axios.get(urlOpcoesTesouroSelic)
	
				console.log(data)
				this.tesouroOptions = data.map(({ ticker_symbol }) => {
					return {
						value: ticker_symbol,
						label: ticker_symbol,
					}
				})
	
				this.hasValueInSearch = true
				this.selectsHasFilled = true;
			} catch (error) {
				GLOBAL.showToastify(error)
				console.error(error)
			} finally {
				this.applyMonetaryMask()
			}
			// this.compareValues()
		},

		onSearch(search, loading) {
		
			if (search.length) {
				loading(true);
				this.getDataOnSearchSelect(loading, search, this);
			}
		},

		getDataOnSearchSelect: debounce(async function (loading, search, vm) {
			try {
				let data;
				
				const response4 = await fetch(`${this.baseURL}/api/tesouro_direto/?ticker_symbol=${search}`)
				const dadosRecebidos = await response4.json();
				data = dadosRecebidos.filter(({ ticker_symbol }) => ticker_symbol !== 'Tesouro Selic')
				this.tesouroOptions = data.map(({ ticker_symbol, tem_info_dividendo }) => {
					return {
						value: ticker_symbol,
						label: ticker_symbol,
						tem_info_dividendo
					}
				})
				loading(false);
				this.isLoading = false;
			}
			catch (error) {
				GLOBAL.showToastify(error)
				console.error(error)
			}
			finally {
				loading(false);
				this.isLoading = false;
			}

		}, 600),

		changeVirgulaToComma(value) {
			return value.replace(',', '.')
		},

		validateInput() {
			this.erros = [];

			if (!this.payloadModal.treasury_bonds_quantity) {
				this.erros.push("Informe a quantidade!")
			}
			if (parseFloat(this.changeToFloatApi(this.payloadModal.treasury_bonds_quantity)) === 0) {
				this.erros.push("A quantidade deve ser maior que zero!")
			}
			if (!this.payloadModal.reference_date) {
				this.erros.push("Informe a data de compra!")
			}
			if (!this.payloadModal.operation_value) {
				this.erros.push("Informe o preço de venda!")
			}
			if (parseFloat(this.changeToFloatApi(this.payloadModal.operation_value)) === 0) {
				this.erros.push("O preço de venda deve ser maior que zero!")
			}
			if (!this.payloadModal.ticker_symbol) {
				this.erros.push("Informe o ativo!")
			}
		},

		showToastifyOnErrorInputs() {
			if (this.erros.length) {
				this.modalValueIsValid = false;
				this.erros.forEach(i => {
					GLOBAL.showToastify(i, '#DE4B4F')
					return
				});
			}
		},

		async onSubmitModalNovoAporte({ currentTarget }) {
			try {
				const payloadMovimentacaoTesouro = { ...this.payloadModal }

				const self = this

				const form = currentTarget.closest("form");
				this.erros = [];

				this.validateInput();
				this.showToastifyOnErrorInputs();

				this.payloadModal.operation_value = this.changeVirgulaToComma(this.payloadModal.operation_value);
				this.payloadModal.treasury_bonds_quantity = this.changeVirgulaToComma(this.payloadModal.treasury_bonds_quantity);
				//this.payloadModal.reference_date = await this.formatDateMovimentacao(this.payloadModal.reference_date);

				if (!this.erros.length) {
					this.tipo_ativo = this.tipo_ativo.value || this.tipo_ativo;
					const productType = document.createElement('input');
					productType.type = 'hidden';
					productType.name = 'product_type';
					productType.value = this.tipo_ativo;

					form.appendChild(productType);

					this.isLoading = true;
					// form.submit();

					payloadMovimentacaoTesouro.reference_date = date.formatDate(payloadMovimentacaoTesouro.reference_date, 'YYYY-MM-DD')

					payloadMovimentacaoTesouro.treasury_bonds_quantity = this.changeToFloatApi(payloadMovimentacaoTesouro.treasury_bonds_quantity)

					payloadMovimentacaoTesouro.operation_value = this.changeToFloatApi(payloadMovimentacaoTesouro.operation_value)

					await axios.post(urlMovimentacaoTesouro, payloadMovimentacaoTesouro)

					await this.getDadosReservaEmergencia()

					setTimeout(() => {
						document.querySelector('[data-xclose]').click()
						self.applyModalAport()
						this.isLoading = false;
					}, 1000);

				}
			} catch (error) {
				console.error(error);
			}
		},

		onCloseModal() {
			this.clearStates();
		},

		clearStates() {
			this.hasValueInSearch = false;
			this.selectsHasFilled = false;
			this.modalValueIsValid = true;
			this.showError = false;
			this.errorMessage = "";
			this.payloadModal = {
				movement_type: "Compra",
				ticker_symbol: "",
				treasury_bonds_quantity: "",
				reference_date: "",
				operation_value: "",
				corretagem: "",
			}
		},

  },

	async mounted() {
		await this.getDadosReservaEmergencia()
  },

  delimiters: ["{*", "*}"], //delimitadores pra n conflitar com o django
}